import request from '@/utils/request'

// 下载
export const trackList = (params: any) =>
  request({
    url: '/front/track-show-config/search',
    method: 'get',
    params
  })

// api/index/get-dropdown
export const getDropdown = (params: any) =>
  request({
    url: '/api/index/get-dropdown',
    method: 'get',
    params
  })

export const trackSubmit = (params: any) =>
  request({
    url: '/front/track-show-config/submit',
    method: 'post',
    data: params
  })

export const updateStatus = (params: any) =>
  request({
    url: '/front/track-show-config/update-status',
    method: 'post',
    data: params
  })

// 指定轨迹提交
export const trackSubmitTrack = (params: any) =>
  request({
    url: '/front/track-show-config/submit-track',
    method: 'post',
    data: params
  })

// 指定轨迹-获取全部渠道（与 /api/common/get-ship-method 一致）
export const getTrackShipMethod = (params: any) =>
  request({
    url: '/front/track-show-config/get-ship-method',
    method: 'get',
    params
  })
